<template>
  <div>
    <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
        <span class="info-box-icon box-green"><i class="ion ion-cash"></i></span>

        <div class="info-box-content">
            <span class="info-box-text">Total Balance</span>
            <span class="info-box-number">{{totalBal(message).toFixed(2)}}</span>
        </div>
        <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
    </div>
    <!-- fix for small devices only -->
    <div class="clearfix visible-sm-block"></div>

    <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
        <span class="info-box-icon box-red"><i class="fa fa-university"></i></span>

        <div class="info-box-content">
            <span class="info-box-text">Bank Balance</span>
            <span class="info-box-number" v-if="message.length > 0">{{((message[4].bank[0][0].totalBankDr + parseFloat(message[4].bank[2][0].totalBankOpeningBalance)) - message[4].bank[1][0].totalBankCr).toFixed(2)}}</span>
        </div>
        <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
    </div>
    <!-- /.col -->
    <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
        <span class="info-box-icon box-blue"><i class="fa fa-inr"></i></span>

        <div class="info-box-content">
            <span class="info-box-text">Cash Balance</span>
            <span class="info-box-number" v-if="message[3]">{{((message[3].cash[0][0].totalCashDr + parseFloat(message[3].cash[2][0].totalCashOpeningBalance)) - message[3].cash[1][0].totalCashCr).toFixed(2)}}</span>
        </div>
        <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
    </div>
    <!-- /.col -->
    
    
    <div class="col-md-3 col-sm-6 col-xs-12">
      <div class="info-box">
        <span class="info-box-icon box-yellow"><i class="fa fa-shopping-bag"></i></span>

        <div class="info-box-content">
            <span class="info-box-text">SMS Balance</span>
            <span class="info-box-number">{{smsbal}}</span>
        </div>
      </div>
        <!-- /.info-box -->
    </div>
    <!-- <div class="col-md-3 col-sm-6 col-xs-12">
      <div class="info-box">
        <span class="info-box-icon box-yellow"><i class="fa fa-shopping-bag"></i></span>

        <div class="info-box-content">
            <span class="info-box-text">Total Interest</span>
            <span class="info-box-number" v-if="message[5].interest[1].totalInterestCr !== null ">{{message[5].interest[1].totalInterestCr}}</span>
            <span class="info-box-number" v-else>0.00</span>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: 'my-component',
  props: ['message'],
  data () {
    return {
      totalAmount: 0,
      smsbal: 0
    }
  },
  methods: {
    loadData () {
      this.$axios.get('user/smsbalance', {headers: { Authorization: 'Bearer ' + localStorage.token }})
      .then((response) => response.data)
      .then((data) => {
        if (data.Balance === '0') {
          this.smsbal = 0
        } else {
          this.smsbal = data.Balance.substring(8)
        }
      })
      .catch(function (error) {
        console.log(error.message)
      })
    },
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    totalBal (message) {
      return ((message[3].cash[0][0].totalCashDr + parseFloat(message[3].cash[2][0].totalCashOpeningBalance)) - message[3].cash[1][0].totalCashCr) + ((message[4].bank[0][0].totalBankDr + parseFloat(message[4].bank[2][0].totalBankOpeningBalance)) - message[4].bank[1][0].totalBankCr)
    }
  },
  created () {
    this.loadData()
  }
}
</script>
<style scoped>
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-red {
    background-color:#ec1c22;
    color: #fff;
  }
  .box-green {
    background-color: #0e8c0e;
    color: #fff;
  }
  .box-blue {
    background-color: #003c60;
    color: #fff;
  }
  .box-yellow {
    background-color: #a300ff;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// balancerecord.vue?df21e3a4